import styled from 'styled-components';

export const FontSelectBoxDiv = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const FontSelectIconDiv = styled.div`
    display: flex;
    align-items: center;
`;

export const FontSelectIcon = styled.i`
    font-size: 17px;
    color: ${({ theme }) => theme.colors.neutral900};
    padding-left: 3px;
`;

export const FontSelectBoldSpan = styled.span`
    font-weight: bold;
`;
